// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Urvt","content":"styles_content__2PcYh","checkbox":"styles_checkbox__1Zqab","checkboxLabel":"styles_checkboxLabel__2dUPc"};